import { MainSubTitle, MainTitle } from "../../Title";
import { Box, Container, Divider, Grid } from "@mui/material";
import { AboutBoxInfo, AboutWrapper } from "styles/jss/Home.styles";
import { PrimaryButton } from "styles/jss/Layout.styles";
import { truncateString } from "utils/helperFunction";
import NextImage from "../../NextImage";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";

export default function AboutSection({ about }) {
  const { t } = useTranslation(["homePage"]);
  const { locale } = useRouter();
  const { btn_url, description, items } = about;

  return (
    <AboutWrapper
      style={{
        background: `url(/images/about_section-home.png) no-repeat center center / cover `,
      }}
    >
      <Container>
        <MainTitle textAlign={"left"}>{t("about-title")}</MainTitle>
        <MainSubTitle textAlign={"left"}>{description}</MainSubTitle>
        <PrimaryButton className={"read-more"}>
          <a href={btn_url}>{t("read-more")}</a>
        </PrimaryButton>
        <Divider variant="middle" sx={{ my: "50px", mx: "0" }} />
        <Grid
          container
          rowSpacing={{ xs: 7.5 }}
          columnSpacing={{ xs: 0, sm: 7 }}
        >
          {items.map(item => (
            <Grid item xs={12} md={6} key={item.id}>
              <Grid
                container
                columnSpacing={{ xs: 0, sm: 3 }}
                rowSpacing={{ xs: 3, sm: 0 }}
                className={"aboutBoxInfo"}
                alignItems="center"
                justifyContent="center"
              >
                <Grid item>
                  <Box className={"imageWrapper"}>
                    <NextImage
                      src={item.img.data.attributes.formats.thumbnail.url}
                      alt={item.title}
                      layout={"fill"}
                      objectFit={"cover"}
                      placeholder="blur"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm className={"content"}>
                  <Link href={item.btn_url || "#"} locale={locale}>
                    <a>
                      <h3 className={"title"}>{item.title}</h3>
                    </a>
                  </Link>
                  <p className={"text"}>
                    {truncateString(item.description, 150)}
                  </p>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Container>
    </AboutWrapper>
  );
}
